import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=043da042&scoped=true"
import script from "./OrganizationCard.vue?vue&type=script&lang=ts"
export * from "./OrganizationCard.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationCard.vue?vue&type=style&index=0&id=043da042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043da042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VTextField})
